import { render, staticRenderFns } from "./vessel-assessment.vue?vue&type=template&id=0021321e&scoped=true"
import script from "./vessel-assessment.vue?vue&type=script&lang=js"
export * from "./vessel-assessment.vue?vue&type=script&lang=js"
import style0 from "./vessel-assessment.vue?vue&type=style&index=0&id=0021321e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0021321e",
  null
  
)

export default component.exports